import React from "react";
import Navbar from "../navbar/Navbar";
import { Outlet } from "react-router-dom";
import "../../global.css";

const Layout = () => {
  return (
    <div className="globalContainer">
      <Navbar />
      <Outlet />
    </div>
  );
};

export default Layout;
